import React, { useEffect, useState } from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  position: relative;
  display: flex;
  margin: 1rem 0;
  border: 1px solid #cccccc;
  padding: 0.75rem;
  border-radius: 0.5rem;

  #iframe-frontrow-quant {
    height: 0px;
  }

  .iframe-frontrow {
    width: 100%;
    margin: 0;
  }
  .iframe-modal-frontrow {
    display: none;
    position: fixed;
    z-index: 99999999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
`
const makeid = (length: number): string => {
  let result = ""
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  const charactersLength = characters.length
  let counter = 0
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
    counter += 1
  }
  return result
}

let quantScriptSrc = ""
let quantIframeSrc = ""

const FrontrowWidget = () => {
  const id = makeid(10)
  const widgetId = "frontrow-widget=" + id

  useEffect(() => {
    if (!quantScriptSrc) {
      quantScriptSrc =
        "https://app.thefrontrowhealth.com/api/widgets/script?presentation_type=quant&product_id=980"
      const quantScript = document.createElement("script")
      quantScript.async = true
      quantScript.src = quantScriptSrc
      document.head.appendChild(quantScript)
    }
    if (!quantIframeSrc) {
      quantIframeSrc =
        "https://app.thefrontrowhealth.com/api/widgets?presentation_type=quant&product_id=980"
    }
    const quantIframe = document.createElement("iframe")
    quantIframe.className = "iframe-frontrow"
    quantIframe.id = "iframe-frontrow-quant"
    quantIframe.frameBorder = "0"
    quantIframe.src = quantIframeSrc
    document?.getElementById(widgetId)?.appendChild(quantIframe)
  }, [])

  return (
    <Wrapper id={widgetId} className="wrap-frontrow">
      {/* <div id="frontrow-badge">
        <iframe
          className="iframe-frontrow"
          id="iframe-frontrow-quant"
          // onLoad={handleLoad()}
          frameborder="0"
          src="https://app.thefrontrowhealth.com/api/widgets?presentation_type=quant&product_id=980"
        ></iframe>
      </div> */}
    </Wrapper>
  )
}

export default FrontrowWidget
